/* 🤖 this file was generated by svg-to-ts */
export const matIconWifiLock: {
  name: 'wifi-lock';
  data: string;
} = {
  name: 'wifi-lock',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21.98 11 24 8.98A16.88 16.88 0 0 0 12 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"/><path d="M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"/></svg>`
};
